import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: '/dev-api',
  baseURL: '/mall',
  // 超时
  timeout: 60,
  headers: featchApiHeader
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (config.data instanceof FormData) { //文件类,文件类不需要stringify
    Object.assign(config.headers, formApiHeader); //修改`Content-Type`
  }
  if (getToken() && !isToken) {
    config.headers['X-Dts-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带jwt token 请根据实际情况自行修改
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.errno || 0;
    // 获取错误信息
    const msg = errorCode[code] || res.data.errmsg || errorCode['default']
    if (code === 501) {
      store.commit('logOut');
      location.href = '/#/PC/login?isLogin=true';
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 0 && code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const commmonHeader = {
  'Accept': 'application/json'
}
/* 常规的 */
export const featchApiHeader = {...commmonHeader,
  'Content-Type': 'application/json;charset=utf-8'
}
export const normalApiHeader = {...commmonHeader,
  'Content-Type': 'application/x-www-form-urlencoded'
}
/* 文件的 */
export const formApiHeader ={...commmonHeader,
  'Content-Type': 'multipart/form-data'
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js